import { jsx as _jsx } from "react/jsx-runtime";
// Global
import { tv } from 'tailwind-variants';
// Local
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { getTestProps } from 'lib/testing/utils';
export const Default = (props)=>{
    const phKeyExtraLarge = `custom-container-extra-large-${props?.params?.DynamicPlaceholderId || 'container-full-bleed'}`;
    const { container, content } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsx("div", {
        className: container(),
        ...getTestProps(`component-container-full-bleed-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx("div", {
            className: content(),
            children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                name: phKeyExtraLarge,
                rendering: props?.rendering
            })
        })
    });
};
const TAILWIND_VARIANTS = tv({
    slots: {
        container: [
            'w-full',
            'flex',
            'flex-col',
            'justify-center',
            'relative',
            'left-[calc(-50vw+50%)]',
            'right-[calc(-50vw+50%)]',
            'w-screen'
        ],
        content: [
            'mx-auto'
        ]
    }
});
